import React from 'react';
import { CategoryIndicator } from './CategoryIndicator';

interface Category {
  label: string;
  contribution: number;
  totalWeight: number;
}

interface CategoriesGridProps {
  categories: Category[];
}

export const CategoriesGrid: React.FC<CategoriesGridProps> = ({ categories }) => {
  return (
    <div className="grid grid-cols-6 gap-4 place-items-center">
      {categories.map((category) => (
        <div key={category.label} className="w-full">
          <CategoryIndicator
            label={category.label}
            contribution={category.contribution}
            totalWeight={category.totalWeight}
          />
        </div>
      ))}
    </div>
  );
};